import { HTTPClient } from "../common/HTTPClient";

import { PaginationRequestParams } from "@/common/mixins/pagination";

export class CategoryClient {
  constructor(private httpClient: HTTPClient) {}

  public async getCategoriesByShopId(shopId: number): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/category/${shopId}`,
      method: "GET"
    });

    return data;
  }
}
